import { render, staticRenderFns } from "./enrollRegist.vue?vue&type=template&id=709f609a&scoped=true&"
import script from "./enrollRegist.vue?vue&type=script&lang=js&"
export * from "./enrollRegist.vue?vue&type=script&lang=js&"
import style0 from "./enrollRegist.vue?vue&type=style&index=0&id=709f609a&prod&lang=css&"
import style1 from "./enrollRegist.vue?vue&type=style&index=1&id=709f609a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709f609a",
  null
  
)

export default component.exports